const mapRelatedComponentIds = ({id}) => id;

const mapAccount = ({id, accountName: name, accountTypeId: typeId, assertions, relatedComponents,executionTypeId}) => ({
	id,
	name,
	typeId,
	assertions: [...assertions],
	relatedComponents: relatedComponents ? relatedComponents.map(mapRelatedComponentIds) : null,
	executionTypeId
});

export default (accounts) => accounts.map(mapAccount);
